<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="hkiarace/admin/event/"
                       data-key="events"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.name_en="{value}">
      <div v-html="value"></div>
    </template>
    <template #item.name_zh="{value}">
      <div v-html="value"></div>
    </template>
    <template #item.signup_mode="{value}">
      {{
        {
          "-1": $t('event_signup_mode.disabled'),
          "1": $t('event_signup_mode.single_session'),
          "2": $t('event_signup_mode.multi_session'),
          "3": $t('event_signup_mode.multi_series'),
        }[value]
      }}
    </template>
    <template #item.quota="{item}">
      {{ item.signup_mode === 1 ? item.quota === -1 ? $t('unlimited') : item.quota : 'N/A' }}
    </template>
    <template v-slot:item.actions="{item}">
      <v-row>
        <v-col>
          <font-awesome-icon icon="edit"
                             @click="editItem(item)"></font-awesome-icon>
        </v-col>
        <v-col>
          <font-awesome-icon icon="trash"
                             @click="deleteItem(item)"></font-awesome-icon>
        </v-col>
      </v-row>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'AdminEventList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_event.name_en'), value: 'base_event.name_en', contains: true},
        {text: root.$t('admin_event.name_zh'), value: 'base_event.name_zh', contains: true},
        {
          text: root.$t('admin_event.signup_mode'), value: 'base_event.signup_mode',
          options: [
            {text: root.$t('event_signup_mode.disabled'), value: -1},
            {text: root.$t('event_signup_mode.single_session'), value: 1},
            {text: root.$t('event_signup_mode.multi_session'), value: 2},
            {text: root.$t('event_signup_mode.multi_series'), value: 3},
          ]
        },
        {
          text: root.$t('admin_memorable_moment.memorable_moment_enabled'), value: 'memorable_moment_enabled',
          options: [
            {text: 'YES', value: true},
            {text: 'NO', value: false},
          ],
        }
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_event.name_en'), value: 'name_en', sortable: false},
      {text: root.$t('admin_event.name_zh'), value: 'name_zh', sortable: false},
      {text: root.$t('admin_event.signup_mode'), value: 'signup_mode', sortable: false},
      {text: root.$t('admin_event.quota'), value: 'quota', sortable: false},

      {text: '', value: 'actions', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = function (item) {
      emit('edit', item);
    };

    const deleteItem = function (item) {
      if (confirm('Confirm Delete Event?')) {
        root.$callAPI('hkiarace/admin/event/delete/', {id: item.id}, function () {
          refresh();
        })
      }
    };


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      deleteItem,
    }
  }
}
</script>
